
import { defineComponent, ref, reactive, computed } from 'vue'

// Composables
import { useTitle } from '@vueuse/core'
import { useRouterOnly } from '@/use/router'
import { useDateRange } from '@/use/date-range'
import { useProject } from '@/org/use-projects'
import { createEmptyErrorMonitor } from '@/alerting/use-monitors'
import { MetricColumn } from '@/metrics/types'

// Components
import DateRangePicker from '@/components/date/DateRangePicker.vue'
import MonitorErrorForm from '@/alerting/MonitorErrorForm.vue'

export default defineComponent({
  name: 'MonitorErrorNew',
  components: {
    DateRangePicker,
    MonitorErrorForm,
  },

  setup(_props, ctx) {
    useTitle('New Metrics Monitor')
    const router = useRouterOnly()
    const dateRange = useDateRange()
    const project = useProject()

    const breadcrumbs = computed(() => {
      const bs: any[] = []

      bs.push({
        text: project.data?.name ?? 'Project',
        to: {
          name: 'ProjectShow',
        },
        exact: true,
      })

      bs.push({
        text: 'Monitors',
        to: {
          name: 'MonitorList',
        },
        exact: true,
      })

      bs.push({ text: 'New error monitor' })

      return bs
    })

    const monitor = reactive(createEmptyErrorMonitor())
    const columnMap = ref<Record<string, MetricColumn>>({})

    function onSave() {
      redirectToMonitors()
    }
    function onCancel() {
      redirectToMonitors()
    }
    function redirectToMonitors() {
      router.push({ name: 'MonitorList' })
    }

    return {
      dateRange,
      breadcrumbs,

      monitor,
      columnMap,

      onSave,
      onCancel,
    }
  },
})
